export const RESET_CHAT = 'TINA_CHAT/RESET_CHAT';
export const UPDATE_CHAT_PARAMS = 'TINA_CHAT/UPDATE_CHAT_PARAMS';
export const SET_MESSAGES = 'TINA_CHAT/SET_MESSAGES';
export const ADD_MESSAGES = 'TINA_CHAT/ADD_MESSAGES';
export const SPLICE_MESSAGES = 'TINA_CHAT/SPLICE_MESSAGES';
